import { PhysicalProductItemType } from '../core';

export class PaginatedItemTypeList {

    private readonly list: PhysicalProductItemType[] = [];
    private readonly offset: number = 20;
    private visibleList: PhysicalProductItemType[] = [];
    private filteredList: PhysicalProductItemType[] = [];
    private filter: string;

    constructor(list: PhysicalProductItemType[]) {
        this.list = list;
        this.setFilter('');
    }

    public getVisibleList(): PhysicalProductItemType[] {
        return this.visibleList;
    }

    public setFilter(filter: string = '') {
        if (filter !== this.filter) {
            this.filter = filter;
            this.filteredList = this.filter ?
                this.list.filter((item) => item.PluralForm.toLowerCase().includes(filter.toLowerCase())) :
                [...this.list];
            this.resetVisibleList();
        }
    }

    public showMore() {
        this.visibleList = [
            ...this.visibleList,
            ...this.filteredList.slice(this.visibleList.length, this.visibleList.length + this.offset)
        ];
    }

    public resetVisibleList() {
        this.visibleList = [];
        this.showMore();
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/paginated-item-type-list.ts